import React from 'react';
import {Layout, Sidebar} from 'react-admin';
import { useSelector } from 'react-redux';
import FrameworkAppBar from './FrameworkAppBar';
import FrameworkAppMenu from './FrameworkAppMenu'
import FrameworkAppContext from "./FrameworkAppContext";

export default React.memo((props) => {

    const AppResources = React.useContext(FrameworkAppContext);
    const theme = useSelector((state: AppState) =>
        state.theme === 'dark' ? AppResources.theme : AppResources.theme
    );
    console.log("FrameworkAppLayout Initializing");


    return (
        <Layout
            {...props}
            title={AppResources.apptitle}
            appBar={FrameworkAppBar}
            menu={FrameworkAppMenu}
            theme={theme}
        />
    )
});

